'use client';

import { Category } from '@/entities/category/model/types';
import { Locale } from '@/shared/types/locale';
import { Box, Button, Image, Text } from '@chakra-ui/react';
import { useLocale } from 'next-intl';
import { useQueryState } from 'nuqs';

type Props = {
  category: Category;
};

const FiltersButton: React.FC<Props> = ({ category }) => {
  const locale = useLocale() as Locale;
  const [selectedCategory, setSelectedCategory] = useQueryState('category');

  const isActive = selectedCategory === category.id;

  const handleClick = () => {
    if (isActive) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(category.id);
    }
  };

  const hasImage = category.image;
  return (
    <Button
      onClick={handleClick}
      variant="plain"
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      h="100%"
      maxW="80px"
      gap="2"
    >
      <Box
        width="56px"
        height="56px"
        bg={hasImage ? 'transparent' : 'gray.200'}
        rounded="lg"
        overflow="hidden"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {hasImage ? (
          <Image
            src={process.env.BASE_URL + category.image}
            alt={category.name[locale]}
          />
        ) : (
          <Text fontSize="xl" fontWeight="semibold">
            {category.name[locale][0]}
          </Text>
        )}
      </Box>
      <Text lineClamp="2" fontWeight={isActive ? 'bold' : 'normal'}>
        {category.name[locale]}
      </Text>
    </Button>
  );
};

export default FiltersButton;
